import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const CustomModal = ({ 
    show, 
    onHide, 
    title, 
    message, 
    type = 'info', // 'info', 'success', 'warning', 'error', 'confirm'
    onConfirm = null,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    showCancel = true,
    confirmVariant = 'primary'
}) => {
    // Determinar el ícono y color según el tipo
    const getIconAndColor = () => {
        switch (type) {
            case 'success':
                return { icon: '✅', color: 'success' };
            case 'error':
                return { icon: '❌', color: 'danger' };
            case 'warning':
                return { icon: '⚠️', color: 'warning' };
            case 'confirm':
                return { icon: '❓', color: 'primary' };
            default:
                return { icon: 'ℹ️', color: 'info' };
        }
    };

    const { icon, color } = getIconAndColor();

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static" style={{ zIndex: 9999 }}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <span className="me-2">{icon}</span>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-0">{message}</p>
            </Modal.Body>
            <Modal.Footer>
                {showCancel && (
                    <Button variant="secondary" onClick={onHide}>
                        {cancelText}
                    </Button>
                )}
                <Button 
                    variant={type === 'confirm' ? confirmVariant : color} 
                    onClick={handleConfirm}
                >
                    {confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomModal;
